import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { Button } from '@/ui_v3';
import { useQuizsetId } from '../../hooks/useQuizsetId';
import { useQuizsetTitle } from '../../hooks/useQuizsetTitle';
export const SideBarFooter = () => {
  const {
    t
  } = useTranslation(['lms']);
  const id = useQuizsetId();
  const quizsetTitle = useQuizsetTitle(id);
  return <div className="flex flex-col gap-md" data-sentry-component="SideBarFooter" data-sentry-source-file="SideBarFooter.tsx">
      <h2 className="line-clamp-2 text-body-lg-semibold text-default">
        {quizsetTitle}
      </h2>
      <Button variant="outlined" intent="alternative" size="md" asChild onClick={() => {
      logger.track('exit_lms');
    }} data-sentry-element="Button" data-sentry-source-file="SideBarFooter.tsx">
        <Link href={`/quiz/${id}`} data-sentry-element="Link" data-sentry-source-file="SideBarFooter.tsx">{t('lms:lms.backToQuiz')}</Link>
      </Button>
    </div>;
};